import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { CurrentTeamAction } from '../action/current-team.action';

@Injectable({
  providedIn: 'root'
})
export class CurrentTeamGuard implements CanDeactivate<any> {

  constructor(
    private currentTeamAction: CurrentTeamAction
  ) {
  }

  canDeactivate(): boolean {
    this.currentTeamAction.removeCurrentTeam();
    return true;
  }

}
